import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import MasterBase from "../components/MasterLayout";
import { getformid, getcontroller, getsubkey, isEmpty } from '../modules/appLibrary';
import { changestatus } from '../modules/formstore';
import { useDispatch, useSelector } from "react-redux";
import ComFunction from "../components/ComFunction";

export const MeiMst = props => {

    const formid = getformid("MeiMst", props.location.search);
    const controller = getcontroller("MeiMst", props.location.search);
    const subkey = getsubkey(props.location.search);
    const dispatch = useDispatch();
    const menuinfo = useSelector(state => state.form.menuinfo);
    const baseref = useRef();
    const ComFunc = React.forwardRef(ComFunction);
    const fnc = useRef();
    const formstatus = useSelector(state => state.form.status);

    const actionurl = {

        "insert": "meimst/Insert",
        "update": "meimst/Update",
        "delete": "bases/Delete",
        "getlist": "meimst/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" }
    ]

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
    }, [menuinfo]);

    function lockcell(e,edit, status) {
        if (status !== "UPDATE") return edit;
        //編集不可
        if (e.data["MID_LOCK"] === '0') {
            if (e.column.colId === "m_code_name2" && e.data["MID_LENNM2"] === '0') return false;
            return edit;
        }
        if (e.data["MID_LOCK"] === '2') return false;   
        //名称のみ編集可
        if (e.data["MID_LOCK"] === '1') {
            if (e.column.colId === "m_code_name") return true;
            else return false;
        }
    }

    function QueryAction(menu) {
        if (menu === "delete") {
            let rowdata = baseref.current.GetSelectrowdata();
            var errdata = rowdata.find(e => e["MID_LOCK"] !== '0');
            if (!isEmpty(errdata)) {
                fnc.current.warnmsg("削除不可種別のデータが選択されています。種別＝" + errdata["m_code_type"] + ":" + errdata["m_code_type_nm"]);
                return false;
            }
        }
        return true;
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                navmenu={navmenu}
                lockcell={lockcell}
                usecondition={true}
                queryaction={QueryAction}
            />
        </div>
    );
};
